// extracted by mini-css-extract-plugin
export default {"container":"WallboardPage_container__AtBB-"};